export default __webpack_public_path__ + "static/media/blr.dd5330e2.svg";